import { render, staticRenderFns } from "./qualityControl.vue?vue&type=template&id=20bf5f8f&"
import script from "./qualityControl.vue?vue&type=script&lang=js&"
export * from "./qualityControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports